import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {MatSort, Sort} from '@angular/material/sort';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {FormControl} from '@angular/forms';
import {MatDialog} from '@angular/material/dialog';
import {Router} from '@angular/router';
import {NationalDrugDTO} from '../../../../models/NationalDrugDTO';
import {TableControl} from '../../../../../common/models/TableControl';
import {DateUtil} from '../../../../../common/util/DateUtil';
import {NationalDrugService} from '../../../../services/national-drug.service';
import {PagedRequestDTO} from '../../../../../common/models/PagedRequestDTO';
import {DisplayIcon} from 'src/app/modules/common/components';
import {
  ConfirmationDialogComponent
} from '../../../../../common/dialogs/confirmation-dialog/confirmation-dialog.component';
import {detailsExpand} from '../../../../../common';
import {createFieldMap, getSortDirection} from '../../../../../common/util/Util';
import {SharedService} from '../../../../../common/services/shared-service';
import {EntityTable} from '../../../../../common/types/entity-table.enum';

@Component({
  selector: 'app-national-drugs',
  templateUrl: './national-drugs.component.html',
  styleUrls: [
    '../../../../../../../styles/global/_management-styles.scss'
  ],
  animations: [detailsExpand]
})
export class NationalDrugsComponent implements OnInit, AfterViewInit {
  readonly DisplayIcon = DisplayIcon;

  nationalDrugFormControl: FormControl;
  nationalDrugDisplayedColumns: string[] = [
    'icons',
    'nationalDrugId',
    'nationalDrugCode',
    'brandName',
    'masterDrug',
    'registrationOwner',
    'referenceName',
    'endDate'
  ];
  nationalDrugDataSource: NationalDrugDTO[];
  nationalDrugTableControl: TableControl;
  nationalDrugExpandedRow: NationalDrugDTO | null;

  isConfirmed = false;
  dateFormat = DateUtil.dateFormat;
  dateTimeFormat = DateUtil.dateTimeFormat;
  length = 100;
  pageSize = 10;
  pageNumber = 0;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  @ViewChild('matSort', {static: false}) tableSort: MatSort;
  @ViewChild('nationalDrugSort', {static: false}) nationalDrugSort: MatSort;
  @ViewChild('nationalDrugPaginator', {static: false}) nationalDrugPaginator: MatPaginator;
  @ViewChild('nationalDrugSearch') private nationalDrugSearch: ElementRef;

  constructor(
    private router: Router,
    public dialog: MatDialog,
    private sharedService: SharedService,
    private nationalDrugService: NationalDrugService,
  ) {
    this.nationalDrugFormControl = new FormControl('');
    this.nationalDrugTableControl = new TableControl(
      this.length,
      this.pageSize,
      this.pageNumber,
      this.pageSizeOptions,
      'nationalDrugId',
      'desc',
      'brandName',
      ''
    );
  }

  ngOnInit(): void {
    this.getListOfNationalDrugs(this.nationalDrugTableControl);
  }

  ngAfterViewInit(): void {
    setTimeout(() => this.nationalDrugSearch.nativeElement.focus(), 0);
  }

  getListOfNationalDrugs(tableControl: TableControl): void {
    const pagedRequestDTO = new PagedRequestDTO();
    pagedRequestDTO.entityClass = EntityTable.TblNationalDrug;
    pagedRequestDTO.pageNumber = tableControl.pageNumber;
    pagedRequestDTO.pageSize = tableControl.pageSize;
    pagedRequestDTO.sortField = tableControl.sortField;
    pagedRequestDTO.sortDirection = getSortDirection(
      tableControl.sortDirection
    );
    pagedRequestDTO.fieldMap = createFieldMap(
      tableControl.filterField,
      tableControl.filterValue
    );

    this.nationalDrugService.getListOfNationalDrugs(pagedRequestDTO).subscribe(
      (response) => {
        this.nationalDrugDataSource = response.resultList;
        this.nationalDrugTableControl.length = response.totalRecords;
      },
      (errorResponse) => {
        const error = errorResponse.error;
        this.sharedService.openErrorDialog(error.businessMessage);
      }
    );
  }

  pageChanged($event: PageEvent) {
    this.nationalDrugTableControl.pageNumber = $event.pageIndex;
    this.nationalDrugTableControl.pageSize = $event.pageSize;
    this.getListOfNationalDrugs(this.nationalDrugTableControl);
  }

  sortData($event: Sort) {
    if (this.nationalDrugPaginator != null) {
      this.nationalDrugPaginator.firstPage();
    }
    this.nationalDrugTableControl.pageNumber = 0;
    this.nationalDrugTableControl.sortField = $event.active;
    this.nationalDrugTableControl.sortDirection = $event.direction;
    this.getListOfNationalDrugs(this.nationalDrugTableControl);
  }

  onInputChangedFilterData(filterField: string) {
    if (this.nationalDrugPaginator != null) {
      this.nationalDrugPaginator.firstPage();
    }
    this.nationalDrugTableControl.pageNumber = 0;
    this.nationalDrugTableControl.filterField = filterField;
    this.nationalDrugTableControl.filterValue = this.nationalDrugFormControl.value;
    this.getListOfNationalDrugs(this.nationalDrugTableControl);
  }

  deleteEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '40vw',
      data: 'Are you sure you wish to delete this entity?'
    });

    dialogRef.afterClosed().subscribe((result) => {
      const isConfirmed = result;
      if (isConfirmed) {
        this.nationalDrugService.deleteNationalDrug(id).subscribe(
          () => {
            this.sharedService.openSnackBar(`National Drug ${id} deleted`, 'Dismiss');
            this.getListOfNationalDrugs(this.nationalDrugTableControl);
          },
          (errorResponse) => {
            const error = errorResponse.error;
            this.sharedService.openErrorDialog(error.businessMessage);
          }
        );
      }
    });
  }

  editEntry(event: MouseEvent, id: number) {
    event.preventDefault();
    event.stopPropagation();

    this.router.navigate(['/pharmacy-management/edit-national-drug/' + id]);
  }

  displayObjectNameIfNotNull(obj: any) {
    return obj == null ? '' : obj.name;
  }

}
